import type {
  ATMDevice,
  ATMAlert,
  FleetKPIs,
  ATMEvent,
} from '@atmvision/types'

// ─── Fleet mock (subset of 933 ATMs) ────────────────────────────────────────

export const MOCK_FLEET: ATMDevice[] = [
  {
    terminal_id: 'DRBR1Y8', model: 'NCR Selfserv 84', family: 'SS-8x Current',
    serial_number: 'NCR84-001234', zone: 'Distrito Nacional', province: 'Distrito Nacional',
    municipality: 'Santo Domingo', address: 'Av. Winston Churchill 1099, Piantini',
    localidad: 'Sucursal Bancaria', lat: 18.4737, lon: -69.9440,
    institucion: 'Banreservas', funcionalidad: 'Retiro+Depósito', acceso: 'Front Access',
    card_reader: 'Motorizado', so_image: 'SS8X_15AGO2025', brigada: 'DNCO-01',
    status: 'IN_SERVICE', last_seen: new Date(Date.now() - 45000).toISOString(),
    cashCassettes: [
      { id: 'C1', denomination: 1000, current: 320, capacity: 500, low_threshold: 80 },
      { id: 'C2', denomination: 500, current: 210, capacity: 400, low_threshold: 60 },
      { id: 'C3', denomination: 200, current: 150, capacity: 400, low_threshold: 60 },
      { id: 'C4', denomination: 100, current: 90, capacity: 300, low_threshold: 50 },
    ],
    devices: [
      { component: 'CDM', status: 'OK' }, { component: 'IDC', status: 'OK' },
      { component: 'PTR', status: 'OK' }, { component: 'UPS', status: 'OK' },
    ],
  },
  {
    terminal_id: 'DRBR2A1', model: 'NCR Selfserv 88', family: 'SS-8x Current',
    serial_number: 'NCR88-007821', zone: 'Distrito Nacional', province: 'Distrito Nacional',
    municipality: 'Santo Domingo', address: 'Av. 27 de Febrero esq. Tiradentes',
    localidad: 'Supermercado', lat: 18.4612, lon: -69.9218,
    institucion: 'Banreservas', funcionalidad: 'Retiro+Depósito', acceso: 'Rear Access',
    card_reader: 'Motorizado', so_image: 'SS8X_15AGO2025', brigada: 'DNCO-02',
    status: 'WARNING', last_seen: new Date(Date.now() - 120000).toISOString(),
    cashCassettes: [
      { id: 'C1', denomination: 1000, current: 75, capacity: 500, low_threshold: 80 },
      { id: 'C2', denomination: 500, current: 180, capacity: 400, low_threshold: 60 },
      { id: 'C3', denomination: 200, current: 200, capacity: 400, low_threshold: 60 },
      { id: 'C4', denomination: 100, current: 140, capacity: 300, low_threshold: 50 },
    ],
    devices: [
      { component: 'CDM', status: 'WARNING', last_error: 'ATM-CDM-003' },
      { component: 'IDC', status: 'OK' }, { component: 'PTR', status: 'FAULT', last_error: 'ATM-PTR-001' },
      { component: 'UPS', status: 'OK' },
    ],
  },
  {
    terminal_id: 'NBRTE4K', model: 'NCR Selfserv 82', family: 'SS-8x Current',
    serial_number: 'NCR82-004561', zone: 'Norte', province: 'Santiago',
    municipality: 'Santiago de los Caballeros', address: 'Av. Juan Pablo Duarte 45, Centro',
    localidad: 'Sucursal Bancaria', lat: 19.4517, lon: -70.6970,
    institucion: 'Banreservas', funcionalidad: 'Retiro', acceso: 'Front Access',
    card_reader: 'DIP', so_image: 'SS8X_15AGO2025', brigada: 'NORD-01',
    status: 'OUT_OF_SERVICE', last_seen: new Date(Date.now() - 3600000).toISOString(),
    cashCassettes: [
      { id: 'C1', denomination: 1000, current: 0, capacity: 500, low_threshold: 80 },
      { id: 'C2', denomination: 500, current: 0, capacity: 400, low_threshold: 60 },
    ],
    devices: [
      { component: 'CDM', status: 'FAULT', last_error: 'ATM-CDM-007' },
      { component: 'IDC', status: 'FAULT', last_error: 'ATM-IDC-002' },
      { component: 'PTR', status: 'OK' }, { component: 'UPS', status: 'WARNING' },
    ],
  },
  {
    terminal_id: 'ESBRP9M', model: 'NCR Selfserv 62', family: 'SS-6x',
    serial_number: 'NCR62-019832', zone: 'Este', province: 'La Altagracia',
    municipality: 'Higüey', address: 'Calle Mella 78, Centro Comercial Las Americas',
    localidad: 'Plaza Comercial', lat: 18.6161, lon: -68.7073,
    institucion: 'Banreservas', funcionalidad: 'Retiro', acceso: 'Front Access',
    card_reader: 'Motorizado', so_image: null, brigada: 'ESTE-02',
    status: 'IN_SERVICE', last_seen: new Date(Date.now() - 15000).toISOString(),
    cashCassettes: [
      { id: 'C1', denomination: 1000, current: 410, capacity: 500, low_threshold: 80 },
      { id: 'C2', denomination: 500, current: 320, capacity: 400, low_threshold: 60 },
    ],
    devices: [
      { component: 'CDM', status: 'OK' }, { component: 'IDC', status: 'OK' },
      { component: 'PTR', status: 'NOT_PRESENT' }, { component: 'UPS', status: 'OK' },
    ],
  },
  {
    terminal_id: 'SURBR7Q', model: 'NCR Selfserv 38', family: 'SS-3x Mid',
    serial_number: 'NCR38-033210', zone: 'Sur', province: 'San Cristóbal',
    municipality: 'San Cristóbal', address: 'Av. Constitución 112',
    localidad: 'Sucursal Bancaria', lat: 18.4176, lon: -70.1051,
    institucion: 'Banreservas', funcionalidad: 'Retiro', acceso: 'Front Access',
    card_reader: 'Motorizado', so_image: 'SS3X_02MAR2025', brigada: 'SUR-01',
    status: 'IN_SERVICE', last_seen: new Date(Date.now() - 30000).toISOString(),
    cashCassettes: [
      { id: 'C1', denomination: 1000, current: 200, capacity: 300, low_threshold: 50 },
      { id: 'C2', denomination: 500, current: 140, capacity: 250, low_threshold: 40 },
    ],
    devices: [
      { component: 'CDM', status: 'OK' }, { component: 'IDC', status: 'OK' },
      { component: 'PTR', status: 'OK' }, { component: 'UPS', status: 'OK' },
    ],
  },
  {
    terminal_id: 'DRBR5L2', model: 'GRG H22VL', family: 'GRG Non-NCR',
    serial_number: 'GRG22-008811', zone: 'Distrito Nacional', province: 'Distrito Nacional',
    municipality: 'Santo Domingo', address: 'Centro Comercial Sambil, Nivel 1',
    localidad: 'Plaza Comercial', lat: 18.4801, lon: -69.9392,
    institucion: 'Banreservas', funcionalidad: 'Retiro', acceso: 'Front Access',
    card_reader: 'DIP', so_image: null, brigada: 'DNCO-03',
    status: 'SUPERVISOR', last_seen: new Date(Date.now() - 600000).toISOString(),
    cashCassettes: [
      { id: 'C1', denomination: 1000, current: 155, capacity: 400, low_threshold: 60 },
      { id: 'C2', denomination: 500, current: 88, capacity: 300, low_threshold: 50 },
    ],
    devices: [
      { component: 'CDM', status: 'OK' }, { component: 'IDC', status: 'WARNING', last_error: 'ATM-IDC-004' },
      { component: 'PTR', status: 'OK' }, { component: 'UPS', status: 'OK' },
    ],
  },
  {
    terminal_id: 'NBRTE8R', model: 'NCR Selfserv 32', family: 'SS-3x Mid',
    serial_number: 'NCR32-044567', zone: 'Norte', province: 'Puerto Plata',
    municipality: 'Puerto Plata', address: 'Av. Hermanas Mirabal, Playa Dorada',
    localidad: 'Hotel', lat: 19.8054, lon: -70.6880,
    institucion: 'Banreservas', funcionalidad: 'Retiro', acceso: 'Rear Access',
    card_reader: 'Motorizado', so_image: 'SS3X_02MAR2025', brigada: 'NORD-02',
    status: 'IN_SERVICE', last_seen: new Date(Date.now() - 60000).toISOString(),
    cashCassettes: [
      { id: 'C1', denomination: 1000, current: 280, capacity: 400, low_threshold: 60 },
      { id: 'C2', denomination: 500, current: 200, capacity: 300, low_threshold: 45 },
    ],
    devices: [
      { component: 'CDM', status: 'OK' }, { component: 'IDC', status: 'OK' },
      { component: 'PTR', status: 'OK' }, { component: 'UPS', status: 'OK' },
    ],
  },
  {
    terminal_id: 'ESBRL3V', model: 'NCR Selfserv 6682 FA', family: 'SS-66xx Modular',
    serial_number: 'NCR6682-002234', zone: 'Este', province: 'Santo Domingo Este',
    municipality: 'Santo Domingo Este', address: 'Av. San Vicente de Paul 89',
    localidad: 'Sucursal Bancaria', lat: 18.4889, lon: -69.8601,
    institucion: 'Banreservas', funcionalidad: 'Retiro+Depósito', acceso: 'Front Access',
    card_reader: 'Motorizado', so_image: 'SS66XX_10ENE2026', brigada: 'ESTE-01',
    status: 'IN_SERVICE', last_seen: new Date(Date.now() - 20000).toISOString(),
    cashCassettes: [
      { id: 'C1', denomination: 2000, current: 190, capacity: 300, low_threshold: 50 },
      { id: 'C2', denomination: 1000, current: 350, capacity: 500, low_threshold: 80 },
      { id: 'C3', denomination: 500, current: 270, capacity: 400, low_threshold: 60 },
      { id: 'C4', denomination: 200, current: 180, capacity: 400, low_threshold: 60 },
    ],
    devices: [
      { component: 'CDM', status: 'OK' }, { component: 'IDC', status: 'OK' },
      { component: 'PTR', status: 'OK' }, { component: 'BNA', status: 'OK' },
      { component: 'UPS', status: 'OK' },
    ],
  },
]

// ─── Mock Alerts ─────────────────────────────────────────────────────────────

export const MOCK_ALERTS: ATMAlert[] = [
  {
    alert_id: 'ALT-001', created_at: new Date(Date.now() - 1800000).toISOString(),
    updated_at: new Date(Date.now() - 900000).toISOString(),
    term_id: 'NBRTE4K', model: 'NCR Selfserv 82', zone: 'Norte',
    canonical_code: 'ATM-CDM-007', description: 'Dispensador bloqueado — cinta atascada',
    severity: 'CRITICAL', priority: 'P1', status: 'OPEN',
    assigned_brigada: 'NORD-01', triggering_events: ['EVT-0091', 'EVT-0092'],
  },
  {
    alert_id: 'ALT-002', created_at: new Date(Date.now() - 3600000).toISOString(),
    updated_at: new Date(Date.now() - 3600000).toISOString(),
    term_id: 'DRBR2A1', model: 'NCR Selfserv 88', zone: 'Distrito Nacional',
    canonical_code: 'ATM-PTR-001', description: 'Impresora de recibos sin papel',
    severity: 'HIGH', priority: 'P2', status: 'ACKNOWLEDGED',
    assigned_brigada: 'DNCO-02', triggering_events: ['EVT-0045'],
  },
  {
    alert_id: 'ALT-003', created_at: new Date(Date.now() - 7200000).toISOString(),
    updated_at: new Date(Date.now() - 7200000).toISOString(),
    term_id: 'DRBR5L2', model: 'GRG H22VL', zone: 'Distrito Nacional',
    canonical_code: 'ATM-IDC-004', description: 'Lector de tarjetas en modo supervisor',
    severity: 'WARNING', priority: 'P3', status: 'OPEN',
    triggering_events: ['EVT-0078'],
  },
  {
    alert_id: 'ALT-004', created_at: new Date(Date.now() - 300000).toISOString(),
    updated_at: new Date(Date.now() - 300000).toISOString(),
    term_id: 'DRBR2A1', model: 'NCR Selfserv 88', zone: 'Distrito Nacional',
    canonical_code: 'ATM-CDM-003', description: 'Nivel de efectivo bajo en cassette C1',
    severity: 'WARNING', priority: 'P3', status: 'OPEN',
    triggering_events: ['EVT-0112'],
  },
  {
    alert_id: 'ALT-005', created_at: new Date(Date.now() - 86400000).toISOString(),
    updated_at: new Date(Date.now() - 82800000).toISOString(),
    term_id: 'SURBR7Q', model: 'NCR Selfserv 38', zone: 'Sur',
    canonical_code: 'ATM-NET-002', description: 'Timeout de red — paquetes perdidos',
    severity: 'HIGH', priority: 'P2', status: 'RESOLVED',
    resolved_at: new Date(Date.now() - 82800000).toISOString(),
    resolution_notes: 'Router reiniciado por brigada SUR-01',
    triggering_events: ['EVT-0033'],
  },
]

// ─── Mock KPIs ────────────────────────────────────────────────────────────────

export const MOCK_KPIS: FleetKPIs = {
  timestamp: new Date().toISOString(),
  total_atms: 933,
  in_service: 847,
  out_of_service: 24,
  warning: 47,
  supervisor: 15,
  availability_pct: 90.8,
  financial_availability_pct: 92.3,
  active_alerts: 37,
  mttr_minutes: 148,
  tx_per_hour: 4820,
  by_zone: {
    'Distrito Nacional': {
      zone: 'Distrito Nacional', total: 312, available: 287,
      availability_pct: 92.0, active_alerts: 14,
    },
    'Norte': {
      zone: 'Norte', total: 241, available: 215,
      availability_pct: 89.2, active_alerts: 11,
    },
    'Sur': {
      zone: 'Sur', total: 198, available: 176,
      availability_pct: 88.9, active_alerts: 8,
    },
    'Este': {
      zone: 'Este', total: 182, available: 169,
      availability_pct: 92.9, active_alerts: 4,
    },
  },
  by_model: {
    'NCR Selfserv 84': { model: 'NCR Selfserv 84', total: 148, available: 141, availability_pct: 95.3, top_errors: [{ canonical_code: 'ATM-CDM-003', count: 4 }] },
    'NCR Selfserv 88': { model: 'NCR Selfserv 88', total: 122, available: 114, availability_pct: 93.4, top_errors: [{ canonical_code: 'ATM-PTR-001', count: 3 }] },
    'NCR Selfserv 82': { model: 'NCR Selfserv 82', total: 98, available: 86, availability_pct: 87.8, top_errors: [{ canonical_code: 'ATM-CDM-007', count: 7 }] },
  },
}

// ─── Mock Events ──────────────────────────────────────────────────────────────

export const MOCK_EVENTS: ATMEvent[] = [
  {
    event_id: 'EVT-0112', ts: new Date(Date.now() - 300000).toISOString(),
    term_id: 'DRBR2A1', model: 'NCR Selfserv 88', zone: 'Distrito Nacional',
    event_type: 'XFS_CDM', raw_code: '3C4A', canonical_code: 'ATM-CDM-003',
    severity: 'WARNING', description: 'Cash cassette C1 below low threshold (75/500)',
    lat: 18.4612, lon: -69.9218, simulated: true, collection_strategy: 'xfs',
  },
  {
    event_id: 'EVT-0091', ts: new Date(Date.now() - 1800000).toISOString(),
    term_id: 'NBRTE4K', model: 'NCR Selfserv 82', zone: 'Norte',
    event_type: 'XFS_CDM', raw_code: 'E7FF', canonical_code: 'ATM-CDM-007',
    severity: 'CRITICAL', description: 'CDM jam detected — transport belt failure',
    lat: 19.4517, lon: -70.6970, simulated: true, collection_strategy: 'xfs',
  },
  {
    event_id: 'EVT-0078', ts: new Date(Date.now() - 7200000).toISOString(),
    term_id: 'DRBR5L2', model: 'GRG H22VL', zone: 'Distrito Nacional',
    event_type: 'XFS_IDC', raw_code: 'IDC_S04', canonical_code: 'ATM-IDC-004',
    severity: 'WARNING', description: 'Card reader entered supervisor mode',
    lat: 18.4801, lon: -69.9392, simulated: false, collection_strategy: 'snmp',
  },
  {
    event_id: 'EVT-0101', ts: new Date(Date.now() - 900000).toISOString(),
    term_id: 'DRBR1Y8', model: 'NCR Selfserv 84', zone: 'Distrito Nacional',
    event_type: 'ISO8583_TX', raw_code: 'TX_OK', canonical_code: null,
    severity: 'INFO', description: 'Transaction approved — DOP 5,000 dispensed',
    lat: 18.4737, lon: -69.9440, simulated: true, collection_strategy: 'hybrid',
  },
]

// ─── Availability trend (last 24h) ───────────────────────────────────────────

export const MOCK_AVAILABILITY_TREND = Array.from({ length: 24 }, (_, i) => {
  const hour = new Date(Date.now() - (23 - i) * 3600000)
  const base = 90 + Math.sin(i / 4) * 3 + (Math.random() - 0.5) * 2
  return {
    time: hour.toLocaleTimeString('es-DO', { hour: '2-digit', minute: '2-digit' }),
    availability: Math.min(99.9, Math.max(80, base)),
    dn: Math.min(99.9, Math.max(80, base + 1.5 + (Math.random() - 0.5))),
    norte: Math.min(99.9, Math.max(80, base - 1 + (Math.random() - 0.5))),
    sur: Math.min(99.9, Math.max(80, base - 2 + (Math.random() - 0.5))),
    este: Math.min(99.9, Math.max(80, base + 2 + (Math.random() - 0.5))),
  }
})

// ─── Top errors by frequency ──────────────────────────────────────────────────

export const MOCK_TOP_ERRORS = [
  { code: 'ATM-CDM-003', component: 'CDM', description: 'Cash level below threshold', count: 48, severity: 'WARNING' },
  { code: 'ATM-CDM-007', component: 'CDM', description: 'Transport belt jam', count: 31, severity: 'CRITICAL' },
  { code: 'ATM-PTR-001', component: 'PTR', description: 'Receipt printer paper out', count: 27, severity: 'HIGH' },
  { code: 'ATM-NET-002', component: 'NET', description: 'Network timeout', count: 24, severity: 'HIGH' },
  { code: 'ATM-IDC-004', component: 'IDC', description: 'Card reader supervisor mode', count: 19, severity: 'WARNING' },
  { code: 'ATM-UPS-001', component: 'UPS', description: 'UPS battery low', count: 15, severity: 'WARNING' },
  { code: 'ATM-CDM-012', component: 'CDM', description: 'Currency cassette removed', count: 12, severity: 'HIGH' },
  { code: 'ATM-SEC-001', component: 'SEC', description: 'Safe door open alert', count: 9, severity: 'CRITICAL' },
  { code: 'ATM-SYS-003', component: 'SYS', description: 'Application restart', count: 8, severity: 'INFO' },
  { code: 'ATM-IDC-001', component: 'IDC', description: 'Card jammed in reader', count: 7, severity: 'HIGH' },
]
